export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/streamlabs_obs.02548d5.svg";